import { downLoad } from './permission'

const downLoadInstall = function(Vue) {
  Vue.directive('downLoad', downLoad);
};

if (window.Vue) {
  window['downLoad'] = downLoad;
  Vue.use(downLoadInstall); // eslint-disable-line
}

downLoad.install = downLoadInstall;
export { downLoad }




// WEBPACK FOOTER //
// ./src/components/permission/index.js